"use strict";

module.exports = require('./wrapFetch');